import { breakpoints } from '@bnnvara/breakpoints';
import { Grid as BaseGrid } from '@bnnvara/grids';
import { Heading as BaseHeading } from '@bnnvara/typography';
import styled from 'styled-components';

export const Grid = styled(BaseGrid)`
  margin: -16px 0px;
  grid-gap: 0px 24px !important;
`;

export const Link = styled.span`
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.primary.main};
  text-decoration: underline;
  display: inline;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ align }) => (align === 'center' ? 'center' : 'left ')};

  ${breakpoints.lg} {
    padding: 40px 120px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
  }
`;

export const Image = styled.img`
  margin: 16px 0;
`;

export const Heading = styled(BaseHeading)`
  margin-bottom: 16px;
`;
